var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{attrs:{"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M12 1.20849L10.7915 0L6 4.79151L1.20849 0L0 1.20849L4.79151 6L0 10.7915L1.20849 12L6 7.20849L10.7915 12L12 10.7915L7.20849 6L12 1.20849Z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }